import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import get from 'lodash.get';
import * as tracking from 'dibs-tracking';

import { FormattedMessage } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button';
import singleItemHoldRequestLauncher from 'dibs-buyer-layout/exports/singleItemHoldRequestLauncher';
import styles from './PdpSharedButtons.scss';

export class PdpSharedRequestHoldComponent extends Component {
    constructor() {
        super();
        this.requestHold = this.requestHold.bind(this);
    }
    componentDidMount() {
        const { hasRequestedHoldForBuyer, displayInfo } = this.props.item || {};
        const queryParams = new URLSearchParams(get(global, 'location.search'));
        const modalParam = queryParams.get('modal');

        if (
            modalParam === 'hold' &&
            !hasRequestedHoldForBuyer &&
            get(displayInfo, 'ctas.showHoldRequest')
        ) {
            this.requestHold();
        }
    }
    requestHold() {
        const {
            relay: { environment },
            itemId,
            userId,
            trackingLocation,
        } = this.props;
        tracking.trackEvent({
            action: 'contact dealer clicked',
            category: 'contact dealer',
            label: `request a hold - ${trackingLocation}`,
        });
        singleItemHoldRequestLauncher({
            environment,
            itemId,
            userId,
            linkLocation: trackingLocation,
        });
    }
    render() {
        const { hasRequestedHoldForBuyer, displayInfo } = this.props.item || {};

        if (hasRequestedHoldForBuyer) {
            return (
                <Button
                    type="secondary"
                    dataTn="pdp-shared-hold-requested"
                    size="small"
                    className={styles.holdRequestedButton}
                    disabled
                >
                    <FormattedMessage
                        id="PdpRespSidebarContact.holdRequested"
                        defaultMessage="Hold requested"
                    />
                </Button>
            );
        }

        if (get(displayInfo, 'ctas.showHoldRequest')) {
            return (
                <Button
                    type="textCta"
                    dataTn="pdp-shared-request-hold"
                    size="medium"
                    disabled={hasRequestedHoldForBuyer}
                    onClick={this.requestHold}
                    className={styles.requestHoldButton}
                >
                    <FormattedMessage
                        id="PdpRespSidebarContact.requestHold"
                        defaultMessage="Request a Hold"
                    />
                </Button>
            );
        }

        return null;
    }
}

PdpSharedRequestHoldComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    trackingLocation: PropTypes.string,
};

export const PdpSharedRequestHold = createFragmentContainer(PdpSharedRequestHoldComponent, {
    item: graphql`
        fragment PdpSharedRequestHold_item on Item {
            hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $isClient)
            displayInfo(page: pdp, buyerId: $userId) @include(if: $isClient) {
                ctas {
                    showHoldRequest
                }
            }
        }
    `,
});
